<template>
    <div class="step-heading__container">
        <h2 class="step-heading">Step {{ shiftedStep }} of {{ Object.values(stepToNameMap).length }} - {{ stepName }}</h2>
        
        <div class="step-bar">
            <span v-for="(stepName, key) in stepToNameMap" class="step-bar__step" :class="{ 'step-bar__step--active': shiftedStep == key }"></span>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('OSB', ['step', 'shortOnlineServiceBooking']),
        shiftedStep() {
            return this.shortOnlineServiceBooking ? this.step - 3 : this.step - 1;
        },

        stepName() {
            return this.stepToNameMap[this.shiftedStep] || 'Unknown step';
        },

        stepToNameMap() {
            if (this.shortOnlineServiceBooking) {
                return {
                    1: 'Options',
                    2: 'Select a date & time',
                };
            }

            return {
                1: 'Find my car',
                2: 'Select a Dealer',
                3: 'Options',
                4: 'Select a date & time',
                5: 'Your summary',
            };
        },
    },
};
</script>
